// Ratings are 1–10 in half-point steps (7, 7.5, 8 …). Stored as numbers on each visit.

export function isHalf(r) {
    return typeof r === 'number' && r % 1 !== 0;
}

/** Whole part shown on the 1–10 buttons. */
export function wholeOf(r) {
    return typeof r === 'number' ? Math.floor(r) : null;
}

/** Tap a number: keep the ½ if it was on (except at 10). */
export function pickWhole(current, n) {
    return isHalf(current) && n < 10 ? n + 0.5 : n;
}

/** Toggle the ½ on the current pick (no-op without a pick or at 10). */
export function toggleHalf(current) {
    if (typeof current !== 'number' || current >= 10) return current;
    return isHalf(current) ? current - 0.5 : current + 0.5;
}

/** '7½' style label (plain '7.5' for screen readers via formatRatingText). */
export function formatRating(r) {
    if (typeof r !== 'number') return '';
    return isHalf(r) ? `${Math.floor(r)}½` : String(r);
}
